import SidebarCompactVersion from './SidebarCompactVersion';

export default SidebarCompactVersion;
